import { Theme } from '../../../typings';
import { getFetch } from '../fetch';
import { apiConfig } from '../config';

interface options {
    page: number;
    pageSize?: number;
    depth: number;
    // TODO вынести слаг уроков в k-common
    subject?: string;
}

export function getThemesFlatFullTree(
    themeId: number,
    {
        page,
        pageSize,
        depth,
        subject,
    }: options = {} as options): Promise<Array<Theme>> {
    const { apiGetThemesFlatFullTree } = apiConfig.getStaticUrls();

    return getFetch(apiGetThemesFlatFullTree, { themeId, page, pageSize, depth, subject });
}
